import { Controller } from 'stimulus'
import './with_remove_button_component.css'

export default class extends Controller {
  remove() {
    this.element.remove()
  }
}
